import Fragment from "react";




export default function Footer (){
    return (
        <>
        <div className="text-center text-white">
            <div className="container p-6">
                <p className="flex justify-center items-center">
                    <span className="mr-4">I have no idea what I'm doing.</span>
                </p>
            </div>

            <div className="text-center p-4">
                © 2022 Copyright: 
                <a className="text-white" href="https://indefinite.tv/about">Indefinite TV</a>
            </div>
        </div>
        </>
    )

}